import { Group } from "@mantine/core"
import type { TActivity } from "@/types"
import { categories } from "@/utils/constants"
import { ActivityCategory } from "./ActivityCategory"

export function ActivityCategories({ activity }: { activity: TActivity }) {
  const badges = categories.filter((c) => activity[c]).map((c) => <ActivityCategory key={c} value={c} />)
  if (!badges.length) return null
  return <Group gap="xs">{badges}</Group>
}
